import userService from "../../../services/user.service";

async function getEmploymentStatuses() {
  try {
    const response = await userService.getEmploymentStatuses(-1, 0 , "");
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to fetch employment statuses."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching employment statuses:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function addEmploymentStatusToDatabase({
  statusName,
  description,
  isActive,
}) {
  try {
    const payload = {
      name: statusName,
      description,
      active: isActive,
    };
    const response = await userService.addEmploymentStatus(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to add employment status."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error adding employment status:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function updateEmploymentStatusInDatabase({
  statusId,
  statusName,
  description,
  isActive,
}) {
  try {
    const payload = {
      id: statusId,
      name: statusName,
      description,
      active: isActive,
    };
    const response = await userService.updateEmploymentStatus(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to update employment status."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error updating employment status:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

export default {
  addEmploymentStatusToDatabase,
  getEmploymentStatuses,
  updateEmploymentStatusInDatabase,
  employmentStatusTools: [
    {
      type: "function",
      function: {
        name: "getEmploymentStatuses",
        description:
          "Fetch all employment statuses from the database. Return all available employment statuses without skipping any data.",
        parameters: {
          type: "object",
          properties: {},
        },
      },
    },
    {
      type: "function",
      function: {
        name: "updateEmploymentStatusInDatabase",
        description: "Update an existing employment status in the database",
        parameters: {
          type: "object",
          properties: {
            statusId: {
              type: "string",
              description: "The unique ID of the employment status to be updated",
            },
            statusName: {
              type: "string",
              description: "Name of the employment status",
            },
            description: {
              type: "string",
              description: "Description of the employment status",
            },
            isActive: {
              type: "boolean",
              description: "Whether the employment status is active or not",
            },
          },
          required: ["statusId", "statusName", "description"],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "addEmploymentStatusToDatabase",
        description: "Add a new employment status to the database",
        parameters: {
          type: "object",
          properties: {
            statusName: {
              type: "string",
              description: "Name of the employment status",
            },
            description: {
              type: "string",
              description: "Description of the employment status",
            },
            isActive: {
              type: "boolean",
              description: "Whether the employment status is active or not",
            },
          },
          required: ["statusName", "description"],
        },
      },
    },
  ],
};
